export const actionTypes = {
  SET_IS_AUTH: "AUTH:SET_IS_AUTH",
  SET_PHONE: "AUTH:SET_PHONE",
  SET_COUNTRY_CODE: "AUTH:SET_COUNTRY_CODE",
  SET_PASSWORD: "AUTH:SET_PASSWORD",
  SET_SIGNING_UP: "AUTH:SET_SIGNING_UP",
  SET_PASSWORD_ERR: "AUTH:SET_PASSWORD_ERR",
  SET_SYSTEM_BAN: "AUTH:SET_SYSTEM_BAN",
  SET_PROFILE_DELETED: "AUTH:SET_PROFILE_DELETED",
  SET_PHONE_ERR: "AUTH:SET_PHONE_ERR",
  SET_IS_PINCODE_NEED: "AUTH:SET_IS_PIN_CODE_NEED",
  SET_PINCODE_ERR: "AUTH:SET_PIN_CODE_ERR",
  SET_IS_FILLING: "AUTH:SET_IS_FILLING",
  SET_IS_VERIFIED: "AUTH:SET_IS_VERIFIED",
  RESET_ALL_AUTH: "AUTH:RESET_ALL",
  SET_WEBCAM: "AUTH:SET_WEBCAM",
  SET_TOKENS: "AUTH:SET_TOKENS",
  SET_TOKEN_IS_VALID: "AUTH:SET_TOKEN_IS_VALID",
  SET_COUNTRIES_LIST: "AUTH:SET_COUNTRIES_LIST",
  SET_CITIES_LIST: "AUTH:SET_CITIES_LIST",
  SET_SOCKET: "AUTH:SET_SOCKET",
  SET_NEED_REFRESH: "AUTH:SET_NEED_REFRESH",
  SET_USED_TOKEN: "AUTH:SET_USED_TOKEN",
  SET_IS_OPEN_MODAL_PHONE: "AUTH:SET_IS_OPEN_MODAL_PHONE",
  SET_IS_TEMP_BLOCKED: "AUTH:SET_IS_TEMP_BLOCKED",
  //fb google
  SET_FB_TOKEN: "AUTH:SET_FB_TOKEN",
  SET_GOOGLE_CODE: "AUTH:SET_GOOGLE_CODE",
  SET_IS_SIGNING_UP_BY_GOOGLE: "AUTH:SET_IS_SIGNING_UP_BY_GOOGLE",
  SET_IS_SIGNING_UP_BY_FB: "AUTH:SET_IS_SIGNING_UP_BY_FB",
  SET_CONFIRMATION_TOKEN: "AUTH:SET_CONFIRMATION_TOKEN",
  //refresh
  SET_REFRESHING: "AUTH:SET_REFRESHING",
  REFRESH: "AUTH:REFRESH",
  FIRST_REFRESH: "AUTH:FIRST_REFRESH",
  OFFLINE: "AUTH:OFFLINE",
  SET_IS_HIDE_AUTH_HEADER: "AUTH:SET_IS_HIDE_AUTH_HEADER"
};

interface setIsAuth {
  type: typeof actionTypes.SET_IS_AUTH;
  payload: boolean;
}

interface setPhone {
  type: typeof actionTypes.SET_PHONE;
  payload: string | null;
}

interface setCountryCode {
  type: typeof actionTypes.SET_COUNTRY_CODE;
  payload: string;
}

interface setPassword {
  type: typeof actionTypes.SET_PASSWORD;
  payload: string | null;
}

interface setSigningUp {
  type: typeof actionTypes.SET_SIGNING_UP;
  payload: boolean;
}

interface setPasswordErr {
  type: typeof actionTypes.SET_PASSWORD_ERR;
  payload: any;
}

interface setSystemBan {
  type: typeof actionTypes.SET_SYSTEM_BAN;
  payload: boolean;
}

interface setProfileDeleted {
  type: typeof actionTypes.SET_PROFILE_DELETED;
  payload: boolean;
}

interface setPhoneErr {
  type: typeof actionTypes.SET_PHONE_ERR;
  payload: boolean;
}

interface setPincodeErr {
  type: typeof actionTypes.SET_PINCODE_ERR;
  payload: boolean;
}

interface setISPinCodeNeed {
  type: typeof actionTypes.SET_IS_PINCODE_NEED;
  payload: boolean;
}

interface setIsFilling {
  type: typeof actionTypes.SET_IS_FILLING;
  payload: boolean
}

interface setIsVerified {
  type: typeof actionTypes.SET_IS_VERIFIED;
  payload: boolean
}

interface resetAll {
  type: typeof actionTypes.RESET_ALL_AUTH;
  payload?: null 
}

export type AuthActionsType =
  | setIsAuth
  | setPhone
  | setCountryCode
  | setPassword
  | setSigningUp
  | setPasswordErr
  | setSystemBan
  | setProfileDeleted
  | setPhoneErr
  | setPincodeErr
  | setISPinCodeNeed
  | setIsFilling
  | setIsVerified
  | resetAll

export interface IsignUpResponse {
  accessToken: string,
  refreshToken: string,
  idProfile: string
}

export const systemBanReasons = {
  0: "Неприемлимый контент",
  1: "Жалобы пользователей",
  2: "Нарушение правил"
}